import {
  createReducer,
  createFetchReducers,
  createFetchActionForNamespace,
  createFetchSelectors
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('locations/detail');

export const fetchLocation = createFetchAction({
  name: 'FETCH_LOCATION',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {locationRef, extraActions}
  }),
  stateKey: 'location',
  defaultStateValue: {}
});

const locationSelector = createFetchSelectors(fetchLocation);
export const selectLocation = locationSelector.data;
export const selectLocationLoading = locationSelector.isLoading;

const reducer = createReducer({}, {...createFetchReducers(fetchLocation)});

export default reducer;

export {default as locationDetailSaga} from './saga';
